<template>
  <svg
    width="28"
    height="31"
    viewBox="0 0 28 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <rect width="28" height="31" fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlink:href="#image0_151_1030"
          transform="scale(0.0357143 0.0322581)"
        />
      </pattern>
      <image
        id="image0_151_1030"
        width="28"
        height="31"
        xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAfCAYAAAD0ma06AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAWtJREFUeNrsV9FxwjAMVUI/+ld98le6QTYoTMCxQRiBCVom6HWCZhPoBhnB3SAjVAL5TqczjtM6ST+qO5+xhXiOnvQcCgjYiownWXbOuRYSrS+2vBFX0zjJeINhFo0tYWK7C6SkoulRbSHtrQf8po1FSmvnNwoFVEsKcIQHa2gcGLhUYB8jgWleYXF5bkRe3I9M35JwvkrhByeqme3UVYqTt8XsfcgydMiMUWnFsYCsfeecaFdpjShNojjXsnR+W2Y+rFclOrtreqUtBZPGiwIABQLG18xeNPPfFoFL1IkSoVpvfJH5hla+s/ElcVgrLo40nhVPxwiH1rf55xBMqvxn5uYz4PN9GPMlAa4VF2A4hAiHnXyX7WEI4I+vH3Owv8uh7idn0qN9bSSuTQFEUd0mpIPmLSzVt7KAupoqEplXU22/5VQXX1uIlJ36yM5kT75odrdyntH2fEHqN28UDd1mBmLK3v2/qG8BBgCxDGaXG/W07AAAAABJRU5ErkJggg=="
      />
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'EventsCalendarSvg',
};
</script>
